(function () {
  'use strict';

  angular
    	.module('MktzapApp.Controllers')
    	.requires
    	.push(
      'ngTable'
    		, 'chart.js'
    	);

  angular.module('MktzapApp.Controllers')
    	.controller('ReportsCampaignGeneralController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationFactory', 'LangService', 'NotificationService'];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationFactory, LangService, NotificationService) {
    var vm = this;

    LangService
      .getPageLabels({ 'page': 'menu.reports.campaign' })
      .$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    vm.filters = {
      companyId: $scope.user_data.company_id,
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY'),
      status: ''
    };

    vm.reload = function () {
      $http.get(apiUrl + '/reports/common/Campaign', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers }) {
          let result = data
          if (result.success === false) {
            if (result.error_message) {
              NotificationService.errorHandler(result, result.error_message);
            } else {
              NotificationService.errorHandler(result, vm.labelsPage.noRecordFound);
            }
            return;
          }

          vm.download(result, status, headers);
        }, function (error) { console.log(error) });
    };

    vm.download = function (data, status, headers) {
      var filename = headers('Mktzap-Filename');

      var anchor = angular.element('<a/>');
      anchor.css({ display: 'none' }); // Make sure it's not visible
      angular.element(document.body).append(anchor); // Attach to document

      var blob = new Blob([data], { type: 'text/csv' });
      var csvUrl = URL.createObjectURL(blob);

      anchor.attr({
        href: csvUrl,
        target: '_self',
        download: filename
      })[0].click();

      anchor.remove(); // Clean it up afterwards
      URL.revokeObjectURL(csvUrl); // Clean memory blob
    }
  }
})();
